import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { DashboardApi } from '../../../../services'
import { IAggregatePublicWaterSystemsMetrics,  ICountyPublicWaterSystemResult, IRegionPublicWaterSystemResult, RequestConfig } from '../../../../types';
import { PublicWaterSystemsAggregatesInitialState, ZoomLevel } from '../publicWaterSystemAggregates.slice';

export const fetchAggregatedWaterSystemsAsync = createAsyncThunk(
  'systems/fetchAggregates',
  async (
    { zoomLevel, stateCode, options }: { zoomLevel: string, stateCode?: string, options?: RequestConfig },
    { rejectWithValue }
  ) => {
    try {
      const response = await DashboardApi.fetchAggregatedWaterSystems(zoomLevel, stateCode, options);
      return (response as AxiosResponse<any>).data;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const fetchAggregatedWaterSystemsAsyncBuilder = (
  builder: ActionReducerMapBuilder<PublicWaterSystemsAggregatesInitialState>
) => {
  builder.addCase(fetchAggregatedWaterSystemsAsync.pending, (state) => {
    state.loading = true;
    state.success = false;
    state.error = '';
  });

  builder.addCase(
    fetchAggregatedWaterSystemsAsync.fulfilled,
    (state, action: PayloadAction<IAggregatePublicWaterSystemsMetrics>) => {
      state.loading = false;
      state.success = true;
  
      if (action.payload.zoomLevel === ZoomLevel.REGION) {
        state.regionsViolations = action.payload.result as IRegionPublicWaterSystemResult[];
      } else if (action.payload.zoomLevel === ZoomLevel.COUNTY) {
        state.countiesViolations = action.payload.result as ICountyPublicWaterSystemResult[];
      }
    }
  );
  

  builder.addCase(
    fetchAggregatedWaterSystemsAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    }
  );
};
